import React from 'react';

const CaseTemplate = ({ rowData }) => {
  const isLead = rowData?.is_lead;
  const caseId = rowData?.case_id;
  const caseName = rowData?.case_name;
  const baseRoute = isLead ? '/leads' : '/cases';

  if (!caseName) {
    return (
      <>
        <span className="p-column-title text-break">Case</span>
        <span className="text-muted">-</span>
      </>
    );
  }

  return (
    <>
      <span className="p-column-title text-break">Case</span>
      <div className="text-truncate">
        <a
          href={`/#${baseRoute}/${caseId}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary-main text-decoration-none"
          style={{ cursor: 'pointer' }}
          onMouseEnter={(e) => (e.target.style.textDecoration = 'underline')}
          onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
        >
          {caseName}
        </a>
      </div>
    </>
  );
};

export default CaseTemplate;
